import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";
const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/integration-management/tenant-api-securities`;

export const accountIntegrationTenantApiSecurityService = {
      getTenantApiSecurity: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get`, {
            params: { id }
        })
        .then((response) => {
            return response.data;
        });
    },
    getTenantApiSecurityList: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/list`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
    createTenantApiSecurity: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create`, params)
            .then((response) => {
                return response.data;
            });
    },
    updateTenantApiSecurity: async function (key: any, params: any) {
        return axios.put(`${GATEWAY_URL}/update`, params)
            .then((response) => {
                return response.data;
            });
    },
     deleteTenantApiSecurity: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/delete`, {
            params
        })
        .then((response) => {
            return response.data;
        });
    },
}